import IntegrityRoleGrid from 'components/UserRole';
import {Column, Lookup} from 'devextreme-react/data-grid';
import {i18n2} from 'features/i18n/i18n';
import React from 'react';
import {useIntegrityCollaborator} from '../hooks/index';
import {lookupActive, lookupRole} from './CollaboGrid';

const IntegrityCollaboGrid = (props: any) => {
  const loadCollabo = useIntegrityCollaborator(props.data.key);

  return (
    <IntegrityRoleGrid
      dataSource={loadCollabo}
      disabledExport={true}
      autoWidth={false}
      id={['employee_Nr']}
      height={'30vh'}
      allowIntegrity={false}
      allowActions={false}>
      <Column caption={i18n2._('Numero de empleado')} dataField="employee_Nr" />
      <Column caption={i18n2._('Nombre')} dataField="name" width={200} />
      <Column caption={i18n2._('CWID')} dataField="cwid" />
      <Column caption={i18n2._('#Sector')} dataField="iD_Sector" />
      <Column caption={i18n2._('#Perfil')} dataField="iD_Profile_Web" />
      <Column caption={i18n2._('#Turno')} dataField="iD_Shift" />
      <Column caption={i18n2._('Role')} dataField="role" visible={false}>
        <Lookup dataSource={lookupRole} valueExpr="id" displayExpr="name" />
      </Column>
      <Column
        caption={i18n2._('Externo')}
        dataField="external"
        dataType="boolean"
        width={90}
        alignment="center"
      />
      <Column caption={i18n2._('Estado')} dataField="active">
        <Lookup dataSource={lookupActive} valueExpr="id" displayExpr="name" />
      </Column>
      <Column caption={i18n2._('Email')} dataField="email" />
      <Column
        caption={i18n2._('Capacitación Inicial')}
        dataField="capa_Initial"
        visible={false}
      />
      <Column
        caption={i18n2._('Alta en el sistema')}
        dataField="onboard_Date"
        visible={false}
      />
      <Column
        caption={i18n2._('Fecha de contratación')}
        dataField="hire_Date"
        visible={false}
      />
      <Column caption={i18n2._('Revision')} dataField="revision" />
      <Column caption={i18n2._('Motivo')} dataField="reason" />
      <Column
        caption={i18n2._('Fecha de actualizacion')}
        dataField="updateDate"
        visible={false}
        defaultSortOrder={'desc'}
        dataType="date"
        format="dd/MM/yyyy"
      />
      <Column
        caption={i18n2._('Actualizado por')}
        dataField="updatedBy"
        visible={false}
      />
    </IntegrityRoleGrid>
  );
};

export default IntegrityCollaboGrid;
